<template>
    <el-dialog
            title="新增日志"
            :append-to-body="true"
            :visible.sync="showTag"
            width="40%"
    >
        <el-form size="mini" ref="form" :model="form" label-width="80px">
            <el-form-item label="时间">
                <el-date-picker :picker-options="{disabledDate}" v-model="form.loggingTime" format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="心率">
                        <el-input style="width: 100px" @input="commonInput('heartRate',3,'心率')"
                                  v-model="form.heartRate"
                        ></el-input>
                        次/min
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="血压">
                        <el-input style="width: 80px"
                                  @input="commonInput('bloodPressureUpper',3,'上压')"
                                  v-model="form.bloodPressureUpper"
                        ></el-input>
                        /
                        <el-input style="width: 80px"
                                  @input="commonInput('bloodPressureLower',3,'下压')"
                                  v-model="form.bloodPressureLower"
                        ></el-input>
                        mmHg
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="氧饱和度">
                        <el-input style="width: 100px"
                                  @input="commonInput('oxygenSaturation',3,'氧饱和度',100)"
                                  v-model="form.oxygenSaturation"
                        ></el-input>
                        %
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="呼吸频率">
                        <el-input style="width: 100px"
                                  @input="commonInput('respiratoryRate',2,'呼吸频率')"
                                  v-model="form.respiratoryRate"
                        ></el-input>
                        次/min
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="日志内容">
                <el-input
                        type="textarea"
                        v-model="form.treatmentProcess"
                ></el-input>
            </el-form-item>
            <el-form-item label="附件资料">
                <el-upload
                        :limit="9"
                        :file-list="picList"
                        :action="UPLOAD_URL"
                        :data="UPLOAD_PARAMS"
                        :headers="UPLOAD_HEADERS"
                        :on-success="onSuccessPic"
                        list-type="picture-card"
                        :on-exceed="onExceed"
                        :on-error="uploadOnError"
                        :before-upload="beforeUpload"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="hide" size="mini">取 消</el-button>
            <el-button type="primary" @click="sub" size="mini">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {staffService} from "../service/staff";
    import {UploadMixin} from "../../../common/lib/mixins/upload";
    import {STAFF_ADD_RECORD_FIELDS} from "../config";
    import dayjs from "dayjs";
    import {disabledDate} from "../filter";

    export default {
        name: "add-record-dialog",
        mixins: [UploadMixin],
        data() {
            let form = {};
            STAFF_ADD_RECORD_FIELDS.forEach(r => {
                form[r] = '';
            })
            return {
                showTag: false,
                info: {},
                form
            };
        },
        methods: {
            disabledDate(value) {
                return !disabledDate(value);
            },
            show(data) {
                this.info = data;
                this.setForm();
                this.showTag = true;
            },
            hide() {
                this.resetForm();
                this.showTag = false;
            },
            commonInput(field, length, label, max = false, min = false) {
                let mb = this.form[field];
                if (/[^\d]+/.test(mb)) {
                    this.$message.error(label + '只能输入数字');
                    mb = mb.replace(/[^\d]+/, '')
                }
                if (mb.length > length) {
                    this.$message.error(label + '为' + length + '位数字');
                    mb = mb.substr(0, length)
                }
                if (max) {
                    if (parseInt(mb) > max) {
                        this.$message.error(label + '最大值不能超过' + max);
                        mb = max
                    }
                }
                if (min !== false) {
                    if (parseInt(mb) < min) {
                        this.$message.error(label + '最小值不能小于' + min);
                        mb = min
                    }
                }
                this.form[field] = mb;
            },
            setForm() {
                const {info} = this;
                STAFF_ADD_RECORD_FIELDS.forEach(r => {
                    info && info[r] && this.$set(this.form, r, info[r]);
                });
                if (!this.form.loggingTime) this.form.loggingTime = dayjs().format("YYYY-MM-DD HH:mm:ss")
                else this.form.loggingTime = dayjs(info.loggingTime).format("YYYY-MM-DD HH:mm:ss");

                if (info.attaList) this.picList = info.attaList.map(r => {
                    return {
                        name: r.attaFileName,
                        url: r.url,
                        response: {
                            code: '0',
                            obj: {
                                attaId: r.attaId
                            }
                        }
                    }
                })
            },
            resetForm() {
                this.picList.splice(0);
            },
            async sub() {
                let form = {...this.form};
                if (!form.attaIdList || !form.attaIdList.length) {
                    form.attaIdList = [];
                }
                form.attaIdList = [
                    ...this.handlerAttaIdList(this.picList)
                ];

                form.loggingTime = dayjs(form.loggingTime).valueOf();
                form.bloodPressure = form.bloodPressureUpper + '/' + form.bloodPressureLower;

                if (form.attaIdList.length === 0) delete form.attaIdList;

                if (form.id) {
                    if (await staffService.modifyRecord(form)) {
                        this.hide();
                        this.resetForm();
                        this.$message.success({
                            message: "修改成功",
                            onClose: () => {
                                this.$emit('ok');
                            }
                        });
                    }
                    return;
                }

                if (await staffService.addRecord(form)) {
                    this.hide();
                    this.resetForm();
                    this.$message.success({
                        message: "添加成功",
                        onClose: () => {
                            this.$emit('ok');
                        }
                    });
                }
            }
        }
    };
</script>

<style scoped></style>
